import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-openings',
  templateUrl: './admin-openings.component.html',
  styleUrls: ['./admin-openings.component.css']
})
export class AdminOpeningsComponent implements OnInit {


  errMessage = "";
  successMessage = "";
  feedbackID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  openings = [];
  users = [];
  form: FormGroup;
  messageErr;
  applicants_sum = 0;
  starred_sum = 0;
  views_sum = 0;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {
     }

  ngOnInit(): void {
    this.fetchBusinesses();
  }

  fetchBusinesses() {

    this.http.get(environment.ADMIN_OPENINGS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.openings = res.message;
          console.log(this.openings)

          for (let i = 0; i < this.openings.length; i++) {
            const element = this.openings[i];
            this.views_sum += element.views_number;

            this.applicants_sum += element.applicants_number;
            this.starred_sum += element.starred_by.length;
            
          }

          //Sort by views_number
          this.openings.sort((a, b) => b.applicants_number - a.applicants_number);

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })


  }

}
